export enum PaymentsStatusEnum {
  All = 0, // Alla
  Failed = 1,
  Completed = 2,
}
